import React, { useContext, useEffect, useRef, useState } from "react";
import BuyStepsTemplate from "../../components/BuyStepsTemplate";
import SubHeader from "../../components/SubHeader";
import Breadcrumb from "../../components/Breadcrumb";
import { AttachPrescriptionButton, ContainerProducts, ContentWrap, DeliveryTitle, FreeShippingNote, Line, PriceInfoContent, PriceInfoWrap, RevisionWrap, StyledButtonPrimary, StyledButtonSecondary, StyledInputRadioCustom, TitleWrap, WarnContainer, WhatWouldLikeToDoTitleWrap } from "./styles";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { descontoNoPix, formatarPercentual } from "../../util/pixPrice";
import { Creators as AddressActions } from "../../store/ducks/address";
import { Creators as OrderActions } from "../../store/ducks/order";
import { Creators as DeliveryContextActions, Origem, selectDescontoPixDoContexto } from "../../store/ducks/deliveryContext";
import { selectFarmaciaManual } from "../../store/ducks/storeByUser";
import AddressSelectionModal from "../../components/AddressSelectionModal";
import DeliveryOptionPicker from "../../components/DeliveryOptionPicker";
import FreeShippingProgress from "../../components/FreeShippingProgress";
import OrderMinimumNotice from "../../components/OrderMinimumNotice";
import { faltaParaPedidoMinimo } from "../../util/orderMinimum";
import api from "../../services/api";
import { toast } from "react-toastify";
import PartlyFulfilledOrderModal from "../../components/PartlyFulfilledOrderModal";
import { formatPrice, textoQuantidadeProdutos } from "../../util/format";
import { DeliverySubtype, DeliveryType } from "../../util/deliveryType";
import HelmetCustom from "../../components/HelmetCustom";
import ProductCard from "../../components/ProductCard";
import AlertInfo from "../../components/AlertInfo";
import ShowAcceptGetItOnDifferentDays from "../../components/ShowAcceptGetItOnDifferentDays";
import PickupModal from "../../components/PickupModal";
import { convertBase64ToFile, convertFileToObject } from "../../util/file";
import { FiPaperclip } from "react-icons/fi";
import ChooseFile from "../../components/ChooseFile";
import { LoadingOverlayContext } from "../../contexts/LoadingOverlayContext";
import { getPrescriptionsByCartId, sendPrescriptionsFilesToCart } from "../../services/gamApi/cartService";
import { getExtractProductsCart, getPromotionsSubtotal, getPromotionsTotal } from "../../util/price";
import { track, mapProductsToItems } from "../../analytics";
import { normalizeCep } from "../../util/deliveryContextStorage";

export default function NewOrderRevision({ history }) {
    const dispatch = useDispatch();

    const [mainAddress, setMainAddress] = useState(null);
    const [showAddressSelectionModal, setShowAddressSelectionModal] = useState(false);
    const [productsStockInfo, setProductStockInfo] = useState([]);
    const [receiveInDifferentsDays, setReceiveInDifferentsDays] = useState(undefined);
    const [promotionOfProductsWithStock, setPromotionOfProductsWithStock] = useState([]);
    const [promotionOfProductsWithoutStock, setPromotionOfProductsWithoutStock] = useState([]);
    const [acceptReceiveOnDifferentsDays, setAcceptReceiveOnDifferentsDays] = useState(false);
    const [acceptReceiveOnDifferentsDaysModal, setAcceptReceiveOnDifferentsDaysModal] = useState(false);
    const [mainOptionDelivery, setMainOptionDelivery] = useState(null);
    const [deliverySubtype, setDeliverySubtype] = useState(null);
    const [prescriptionFiles, setPrescriptionFiles] = useState(null);
    const [canAttachPrescriptionFile, setCanAttachPrescriptionFile] = useState(false);
    const [showPickupModal, setShowPickupModal] = useState(false);
    const [responsibleWithdrawal, setResponsibleWithdrawal] = useState(null);
    const [deliveryMultiplicationFactor, setDeliveryMultiplicationFactor] = useState(1);
    const [showSendPrescriptionFileModal, setShowSendPrescriptionFileModal] = useState(false);
    const [deliveryUnavailableByCoverage, setDeliveryUnavailableByCoverage] = useState(false);
    const [freteGratisRevisao, setFreteGratisRevisao] = useState({ normal: false, expressa: false, valorMinimo: 0, ativo: false });
    const { setLoadingOverlay } = useContext(LoadingOverlayContext);
    const addressesLoadingStarted = useRef(false);
    // O endereço da venda assistida é aplicado uma vez; depois vale a escolha do cliente.
    const assistedSaleAddressApplied = useRef(false);

    const { programa_fidelidade = false } = useSelector((state) =>
        state.user.profile == null ? false : state.user.profile
    );
    const { obrigar_envio_receita_produto_tv, obrigar_envio_receita_produto_tvr, obrigar_envio_receita_produto_tp, aceitar_delivery_produto_tv, aceitar_delivery_produto_tvr, aceitar_delivery_produto_tp } = useSelector((state) =>
        state.store.data == null ? "" : state.store.data.empresa
    );
    const { loading: loadingAddresses, data: addresses } = useSelector(state => state.address);
    const deliveryContext = useSelector(state => state.deliveryContext);
    const descontoPixContexto = useSelector(selectDescontoPixDoContexto, shallowEqual);
    const cart = useSelector((state) => state.cart);
    // Farmacia escolhida pelo cliente. O checkout usa este objeto inteiro --
    // tempo_contingencia_gam, horarios, id -- e a farmacia resolvida pelo contexto de
    // entrega tem so id e uuid.
    const store = useSelector(selectFarmaciaManual);

    const isPickupOnlyProduct = item =>
        (item.tarja === "P" && !aceitar_delivery_produto_tp) ||
        (item.tarja === "V" && item.retem_receita && !aceitar_delivery_produto_tvr) ||
        (item.tarja === "V" && !item.retem_receita && !aceitar_delivery_produto_tv);
    const deliveryUnavailableByProductStrip = cart?.data?.itens?.some(isPickupOnlyProduct) ?? false;
    const deliveryUnavailableByMissingAddress = !loadingAddresses && !mainAddress;
    const deliveryUnavailable = deliveryUnavailableByProductStrip || deliveryUnavailableByMissingAddress;
    const deliveryUnavailableMessage = deliveryUnavailableByProductStrip
        ? "Opção de entrega indisponível: existem produtos que não permitem entrega em domicílio"
        : deliveryUnavailableByCoverage
            ? "Opção de entrega indisponível: nenhuma loja atende ao seu endereço."
            : deliveryUnavailableByMissingAddress
            ? "Opção de entrega indisponível: sem endereço cadastrado."
            : null;

    const { promotions, distinctProductsIdCount } = getExtractProductsCart(cart.data.itens, programa_fidelidade);
    const subtotal = getPromotionsSubtotal(promotions);
    const total = getPromotionsTotal(promotions);
    const taxaEntregaCheia = mainOptionDelivery?.tipoEntrega === DeliveryType.RECEBER_EM_CASA
        ? Number(mainOptionDelivery.freteConfiguradoVendaAssistida
            ? mainOptionDelivery.valorFreteVendaAssistida
            : (deliverySubtype === DeliverySubtype.EXPRESSA && mainOptionDelivery.local_entrega?.permite_entrega_expressa
                ? mainOptionDelivery.local_entrega.custo_entrega_expressa
                : (mainOptionDelivery.local_entrega?.custo_entrega ?? mainOptionDelivery.custo_entrega)) * deliveryMultiplicationFactor)
        : 0;
    const isEntregaNormalSelecionada = mainOptionDelivery?.tipoEntrega === DeliveryType.RECEBER_EM_CASA && !deliverySubtype;
    const isEntregaExpressaSelecionada = mainOptionDelivery?.tipoEntrega === DeliveryType.RECEBER_EM_CASA && deliverySubtype === DeliverySubtype.EXPRESSA;
    const entregaGratisNaRevisao = (isEntregaNormalSelecionada && freteGratisRevisao.normal) || (isEntregaExpressaSelecionada && freteGratisRevisao.expressa);
    const taxaEntregaRevisao = entregaGratisNaRevisao ? 0 : taxaEntregaCheia;
    // Desconto do Pix online da loja do pedido (sem ela, da farmácia do contexto), informativo abaixo do total (P-113)
    const pixDaLoja = mainOptionDelivery?.formaPagamento?.online?.find((forma) => forma.tipo === "PI");
    const pisoPagamentoOnline = useSelector(state => Number(state.store.data?.empresa?.valor_minimo_pagamento_online) || 0);
    const abaixoPisoOnline = total + taxaEntregaRevisao < pisoPagamentoOnline;
    const percPix = abaixoPisoOnline
        ? 0
        : mainOptionDelivery
            ? Number(pixDaLoja?.perc_desconto) || 0
            : (descontoPixContexto.conhecida ? descontoPixContexto.perc : 0);
    const descontoPix = descontoNoPix(total, percPix);
    // Pedido mínimo da loja (decisão 0017): sem atingir, não avança
    const valorMinimoPedido = useSelector(state => state.store.data?.empresa?.valor_minimo_pedido);
    const faltaMinimo = faltaParaPedidoMinimo(total, valorMinimoPedido);
    // O servidor calcula o mínimo depois do desconto da forma de pagamento, que só é escolhida no
    // próximo passo: avisar quando alguma forma da loja tira o pedido do mínimo.
    const formasPagamentoLoja = [
        ...(mainOptionDelivery?.formaPagamento?.online || []),
        ...(mainOptionDelivery?.formaPagamento?.presencial || []),
    ];
    const maiorDescontoPagamento = formasPagamentoLoja.length
        ? Math.max(...formasPagamentoLoja.map(forma => Number(forma.perc_desconto) || 0))
        : null;
    const freteGratisSujeitoPagamento = entregaGratisNaRevisao && (maiorDescontoPagamento === null
        || total * (1 - maiorDescontoPagamento / 100) < freteGratisRevisao.valorMinimo);

    useEffect(() => {
        dispatch(AddressActions.getAddressesRequest());
    }, [dispatch])

    useEffect(() => {
        if (loadingAddresses) {
            addressesLoadingStarted.current = true;
            setLoadingOverlay(true)
        } else if (addressesLoadingStarted.current) {
            addressesLoadingStarted.current = false;
            setLoadingOverlay(false)
            const selectedAddress = selectMainAddress(addresses)
            if (!selectedAddress)
                setShowAddressSelectionModal(true)
        }
    }, [loadingAddresses, addresses])

    useEffect(() => {
        loadProductsFromStore(cart, mainOptionDelivery, deliverySubtype)
        if (mainOptionDelivery?.tipoEntrega === DeliveryType.RECEBER_EM_CASA) {
            setResponsibleWithdrawal(null)
        }
    }, [mainOptionDelivery, cart, deliverySubtype])

    useEffect(() => {
        if (cart)
            checkPrescriptionFileRequirement(cart?.data, obrigar_envio_receita_produto_tp, obrigar_envio_receita_produto_tvr, obrigar_envio_receita_produto_tv)
    }, [cart, obrigar_envio_receita_produto_tv, obrigar_envio_receita_produto_tvr, obrigar_envio_receita_produto_tp])

    useEffect(() => {
        splitProductsByContingency(productsStockInfo, receiveInDifferentsDays, programa_fidelidade)
    }, [productsStockInfo, receiveInDifferentsDays, programa_fidelidade])

    useEffect(() => {
        if (receiveInDifferentsDays)
            setDeliveryMultiplicationFactor(2)
        else
            setDeliveryMultiplicationFactor(1)
    }, [receiveInDifferentsDays])

    function checkPrescriptionFileRequirement(cart, obrigar_envio_receita_produto_tp, obrigar_envio_receita_produto_tvr, obrigar_envio_receita_produto_tv) {
        if (cart && cart.itens && cart.itens.length > 0) {
            const formattedItemsCart = cart.itens.map(item => {
                return {
                    strip: item.tarja,
                    retainsRevenue: item.retem_receita
                }
            });
            setCanAttachPrescriptionFile(formattedItemsCart.some(item => (
                item.strip === 'P' && obrigar_envio_receita_produto_tp) || (item.strip === 'V' && item.retainsRevenue && obrigar_envio_receita_produto_tvr) || (item.strip === 'V' && obrigar_envio_receita_produto_tv))
            );
        }
    }

    function selectMainAddress(addresses) {
        if (addresses && addresses.length > 0) {
            // Cesta da venda assistida: o endereço combinado com o atendente vale sobre o
            // contexto de entrega salvo no navegador (que pode ser de outra navegação). O
            // contexto é alinhado para a loja e o frete serem calculados sobre ele.
            const assistedSaleAddress = !assistedSaleAddressApplied.current &&
                cart?.data?.vendaAssistida && cart?.data?.enderecoId
                ? addresses.find(address => address.id === cart.data.enderecoId)
                : null;
            if (assistedSaleAddress) {
                assistedSaleAddressApplied.current = true;
                if (deliveryContext.enderecoId !== assistedSaleAddress.id)
                    selectCheckoutAddress(assistedSaleAddress);
                else
                    setMainAddress(assistedSaleAddress);
                return assistedSaleAddress;
            }

            const customerAddressId = deliveryContext.enderecoId || history.location.state?.customerAddressId;
            const selectedAddress = addresses.find(address => address.id === customerAddressId);
            const addressWithSelectedCep = addresses.find(address =>
                normalizeCep(address.cep) === deliveryContext.cep
            );

            // CEP avulso representa um local ainda não cadastrado. Não substituímos esse
            // local silenciosamente pelo primeiro endereço do cliente.
            const mainAddress = selectedAddress || addressWithSelectedCep ||
                (deliveryContext.origem === Origem.MANUAL_CEP ? null : addresses[0]);
            setMainAddress(mainAddress);
            return mainAddress;
        }

        setMainAddress(null);
        return null;
    }

    function selectCheckoutAddress(address) {
        setMainAddress(address);

        if (address) {
            dispatch(DeliveryContextActions.selectAddress(address.id, normalizeCep(address.cep), {
                cidade: address.cidade?.nome || null,
                uf: address.cidade?.uf_sigla || null,
                bairro: address.bairro || null
            }));
        }
    }

    async function verifyExistenceProductStock(cart, store) {
        let isValid = false;
        if (cart && cart.data && cart.data.itens && store) {

            let finalBasket = [];

            cart.data.itens.forEach((product) => {
                const productFound = finalBasket.find((item) => item.id === product.id);

                if (!productFound) {
                    finalBasket.push({ id: product.id, nome: product.nome, quantidade: product.quantidade })
                }
            })

            try {
                const { data } = await api.post(
                    `/orders/check-store-stock${store !== null ? `/${store.uuid}` : ''}`,
                    {
                        storeId: store.id,
                        items: finalBasket
                    }
                )
                if (data.itensNaoAtendidos.length > 0) {
                    dispatch(OrderActions.showOutOfStockItems(data));
                } else {
                    isValid = true
                }
            } catch (e) {
                toast.error(e.response?.data?.user || 'Erro ao validar estoque');
            }
        }

        return isValid
    }

    function loadProductsFromStore(cart, store, deliverySubtype) {
        if (cart) {
            let treatedProducts = [];

            let canWaitStore = true;

            if (store) {
                const nextTimeStoreOpened = getNextTimeStoreOpened(store, deliverySubtype);
                let [date, timeRange] = nextTimeStoreOpened.split(' ');
                let [, endTime] = timeRange.split('-');
                const endTimeBeforeClose = new Date(`${date} ${endTime}`);
                const maxWaitingDate = new Date();
                maxWaitingDate.setHours(maxWaitingDate.getHours() + store.tempo_contingencia_gam);
                canWaitStore = maxWaitingDate <= endTimeBeforeClose;
            }

            cart.data.itens.forEach(product => {
                const stock = product.estoques?.find(e => e.loja_id === store?.id)
                var quantityNeededInStoreStock = stock && stock.quantidade_associada > 0 ? (product.quantidade > stock.quantidade_associada ? stock.quantidade_associada : product.quantidade) : 0;
                const quantityMissing = product.quantidade - quantityNeededInStoreStock;
                const gamStock = stock ? (stock.quantidade - stock.quantidade_associada) : 0;
                var quantityNeededInGamStock = gamStock > 0 ? (quantityMissing > gamStock ? gamStock : quantityMissing) : 0;

                //predict whether the product will be in stock by the next store opening
                if (canWaitStore) {
                    quantityNeededInStoreStock += quantityNeededInGamStock;
                    quantityNeededInGamStock = 0;
                }

                // Keep products without stock information in the revision. Their
                // availability is still confirmed by the backend before payment.
                treatedProducts.push({ product: { ...product }, maxTotalFirstDelivery: quantityNeededInStoreStock, maxTotalSecondDelivery: quantityNeededInGamStock });
            });

            if (treatedProducts.length > 0) {
                setProductStockInfo(treatedProducts);
            }
        }
    }

    function splitProductsByContingency(productsStockInfo, receiveInDifferentsDays, hasFacilityProgram) {
        let promotionsWithStock = [];
        let promotionsWithoutStock = [];
        if (productsStockInfo.length > 0) {
            const thereAreProductsInStockAssociadaAndGam = productsStockInfo.some(p => p.maxTotalFirstDelivery > 0) && productsStockInfo.some(p => p.maxTotalSecondDelivery > 0);
            setAcceptReceiveOnDifferentsDays(thereAreProductsInStockAssociadaAndGam);

            const acceptReceiveOnDifferentsDays = thereAreProductsInStockAssociadaAndGam && receiveInDifferentsDays;

            const productsStockSplit = productsStockInfo.map(productStockInfo => ({
                productId: productStockInfo.product.id,
                totalFirstDelivery: productStockInfo.maxTotalFirstDelivery ? productStockInfo.maxTotalFirstDelivery : 0,
                totalSecondDelivery: acceptReceiveOnDifferentsDays ? productStockInfo.maxTotalSecondDelivery : productStockInfo.maxTotalSecondDelivery > 0 ? productStockInfo.maxTotalFirstDelivery + productStockInfo.maxTotalSecondDelivery : 0,
            }));

            const { promotions } = getExtractProductsCart(productsStockInfo.map(p => p.product), hasFacilityProgram)

            promotions.forEach(promotion => {
                const productStockInfoIndex = productsStockSplit.findIndex(p => p.productId === promotion.product.id);
                const promotionQuantity = promotion.promotionQuantity;
                const totalFirstDelivery = productsStockSplit[productStockInfoIndex].totalFirstDelivery;
                const totalSecondDelivery = productsStockSplit[productStockInfoIndex].totalSecondDelivery;
                let associadaQuantity = 0;
                let gamQuantity = 0;

                if (totalFirstDelivery > 0) {
                    associadaQuantity = promotionQuantity <= totalFirstDelivery ? promotionQuantity : totalFirstDelivery;
                }

                if (totalSecondDelivery > 0) {
                    gamQuantity = promotionQuantity > associadaQuantity ? promotionQuantity - associadaQuantity : 0;
                }

                if (gamQuantity > 0) {
                    promotionsWithoutStock.push({ ...promotion, promotionQuantity: gamQuantity, product: { ...promotion.product, quantidade: gamQuantity } });
                }

                const unavailableQuantity = promotionQuantity - associadaQuantity - gamQuantity;
                const quantityInCurrentList = associadaQuantity + unavailableQuantity;
                if (quantityInCurrentList > 0) {
                    promotionsWithStock.push({ ...promotion, promotionQuantity: quantityInCurrentList, product: { ...promotion.product, quantidade: quantityInCurrentList } });
                }

                productsStockSplit[productStockInfoIndex].totalFirstDelivery -= associadaQuantity;
                productsStockSplit[productStockInfoIndex].totalSecondDelivery -= gamQuantity;
            });
        }

        setPromotionOfProductsWithStock(promotionsWithStock);
        setPromotionOfProductsWithoutStock(promotionsWithoutStock);
    }

    function getNextTimeStoreOpened(selectedStore, deliverySubtype) {
        if (selectedStore) {
            const initTime = deliverySubtype === DeliverySubtype.EXPRESSA ? selectedStore.lojaHorarioExpresso?.hora_inicio : selectedStore.lojaHorario?.hora_inicio;
            const endTime = deliverySubtype === DeliverySubtype.EXPRESSA ? selectedStore.lojaHorarioExpresso?.hora_fim : selectedStore.lojaHorario?.hora_fim;
            const storeOpeningDate = deliverySubtype === DeliverySubtype.EXPRESSA ? selectedStore.lojaHorarioExpresso?.data_disponibilidade : selectedStore.lojaHorario?.data_disponibilidade;
            return `${storeOpeningDate} ${initTime.split(':').slice(0, 2).join(':')}-${endTime.split(':').slice(0, 2).join(':')}`;
        }
    }

    const handleReveived = (e) => {
        setReceiveInDifferentsDays(e.target.value === "S");
    }

    async function continueToPayment() {
        let navigationStarted = false;

        try {
            setLoadingOverlay(true);
            if (mainOptionDelivery?.tipoEntrega === DeliveryType.RECEBER_EM_CASA && canAttachPrescriptionFile) {
                try {
                    const result = await getPrescriptionsByCartId(cart.data.carrinhoId);
                    if (!(result.data && result.data.receitas && result.data.receitas.length > 0)) {
                        toast.error("Sua cesta possui produtos que precisam de receitas. Por favor, anexe as receitas antes de prosseguir.");
                        setShowSendPrescriptionFileModal(true);
                        return;
                    }
                } catch (e) {
                    if (e.response?.data?.type !== 'ERROR_CART_NOT_FOUND') {
                        toast.error('Não foi possivel confirmar as receitas para a cesta. Por favor, tente novamente e contate-nos se o problema persistir.');
                        return;
                    }
                }
            }

            const showModal = promotionOfProductsWithStock.length > 0 && promotionOfProductsWithoutStock.length > 0 && receiveInDifferentsDays;
            if (showModal)
                setAcceptReceiveOnDifferentsDaysModal(true);
            else
                navigationStarted = await confirmContinueToPayment(receiveInDifferentsDays !== undefined ? receiveInDifferentsDays : undefined);
        } catch (e) {
            toast.error('Um erro inesperado ocorreu ao prosseguir com seu pedido. Por favor, tente novamente e contate-nos se o problema persistir.');
        } finally {
            if (!navigationStarted)
                setLoadingOverlay(false);
        }
    }

    const confirmContinueToPayment = async (receiveInDifferentsDays, cartToValidate = cart, keepOnRevision = false) => {
        let navigationStarted = false;
        const selectedDeliveryOption = mainOptionDelivery;
        const selectedDeliverySubtype = deliverySubtype;

        try {
            setLoadingOverlay(true);

            const hasStock = await verifyExistenceProductStock(cartToValidate, selectedDeliveryOption)
            if (hasStock) {
                if (keepOnRevision)
                    return false;

                let finalBasket = [];

                cartToValidate.data.itens.forEach((product) => {
                    const productFound = finalBasket.find((item) => item.id === product.id);

                    if (!productFound) {
                        finalBasket.push({ id: product.id, nome: product.nome, quantidade: product.quantidade })
                    }
                })

                const formatedFiles = prescriptionFiles ? await Promise.all(prescriptionFiles.map(async file => {
                    return await convertFileToObject(file)
                })) : null;

                localStorage.setItem("@ConexaoGAM:checkout", JSON.stringify({
                    dadosEntrega: {
                        tipoEntrega: selectedDeliveryOption.tipoEntrega,
                        subtipoEntrega: selectedDeliverySubtype,
                        lojaSelecionada: selectedDeliveryOption,
                        dadosTerceiro: responsibleWithdrawal && responsibleWithdrawal.retirada_terceiro === "true" ? { nomeCompleto: responsibleWithdrawal.nome_completo, cpf: responsibleWithdrawal.cpf?.replace(/[^\d]+/g, ""), telefone: responsibleWithdrawal.telefone_contato?.replace(/[^\d]+/g, "") } : null,
                        enderecoCliente: mainAddress,
                        receberEmDiasDiferentes: receiveInDifferentsDays,
                        possuiItensGam: receiveInDifferentsDays === true &&
                            productsStockInfo.some((p) => p.maxTotalSecondDelivery > 0)
                    },
                    address: mainAddress,
                    itensAtendidos: finalBasket,
                    prescriptionFiles: formatedFiles
                }));
                navigationStarted = true;
                history.push("/checkout/pagamento")
            }

            return navigationStarted;
        } finally {
            if (!navigationStarted)
                setLoadingOverlay(false);
        }
    }

    function keepBuying() {
        history.push("/");
    }

    // add_shipping_info: 1 evento, 2 shipping_tier. Dedupe por tier porque os cards do
    // DeliveryOptionPicker disparam em onClick E onBlur (mesma seleção repetida).
    const lastShippingTierRef = useRef(null);
    function trackShippingInfo(shipping_tier) {
        if (lastShippingTierRef.current === shipping_tier) return;
        lastShippingTierRef.current = shipping_tier;
        const items = mapProductsToItems(cart.data.itens, programa_fidelidade);
        track("add_shipping_info", { shipping_tier, items, value: cart.amount });
    }

    function onChoosePickupStore(store, responsibleWithdrawal) {
        setMainOptionDelivery(store);
        setResponsibleWithdrawal(responsibleWithdrawal);
        trackShippingInfo("retirada");
    }

    function onSelectMainOptionDelivery(optionDelivery, subtype) {
        setMainOptionDelivery(optionDelivery);
        setDeliverySubtype(subtype);
        // clearOptions() chama com null — não é seleção do usuário; reseta o dedupe.
        if (optionDelivery) trackShippingInfo("entrega");
        else lastShippingTierRef.current = null;
    }

    async function openAttachPrescriptionsFileModal() {
        try {
            setLoadingOverlay(true);
            const result = await getPrescriptionsByCartId(cart.data.carrinhoId);
            const prescriptionFilesFormated = []
            if (result.data && result.data.receitas && result.data.receitas.length > 0)
                prescriptionFilesFormated.push(...result.data.receitas.map(prescriptionFile => convertBase64ToFile(prescriptionFile.base64, prescriptionFile.nome)))
            setPrescriptionFiles(prescriptionFilesFormated);
            setShowSendPrescriptionFileModal(true);
            console.log(result);
        } catch (e) {
            toast.error(e.response?.data?.user || "Erro ao obter prescrições");
        } finally {
            setLoadingOverlay(false);
        }
    }

    async function savePrescriptionToCart(prescriptionsFiles) {

        try {
            setLoadingOverlay(true);
            await sendPrescriptionsFilesToCart(prescriptionsFiles, cart.data.carrinhoId);
            track("upload_receita", { tem_receita: true, arquivo_count: prescriptionsFiles?.length || 0 });
            toast.success("Prescrições salvas com sucesso");
            setShowSendPrescriptionFileModal(false);
        } catch (e) {
            toast.error(e.response?.data?.user || "Erro ao salvar prescrições");
        } finally {
            setLoadingOverlay(false);
        }
    }

    return (
        <BuyStepsTemplate step={2} history={history}>
            <HelmetCustom pageTitle="Revisão" />
            <Breadcrumb
                items={[{ name: "Cesta de compras" }, { name: "Revisão do pedido" }]}
                jsonLd={false}
            />
            <SubHeader title="Revisão do pedido" />
            <ContentWrap>
                <RevisionWrap>
                    {!loadingAddresses && (
                        <DeliveryOptionPicker customerAddressId={mainAddress?.id} cart={cart} store={store} mainOptionDelivery={mainOptionDelivery} deliverySubtype={deliverySubtype} setMainOptionDelivery={onSelectMainOptionDelivery} showOverlay={setLoadingOverlay} showPickupModal={() => setShowPickupModal(true)} responsibleWithdrawal={responsibleWithdrawal} deliveryMultiplicationFactor={deliveryMultiplicationFactor} mainAddress={mainAddress} loadingAddresses={loadingAddresses} showSelectedAddressModal={() => setShowAddressSelectionModal(true)} deliveryUnavailable={deliveryUnavailable} deliveryUnavailableMessage={deliveryUnavailableMessage} canRegisterAddress={deliveryUnavailableByMissingAddress} onDeliveryCoverageUnavailableChange={setDeliveryUnavailableByCoverage} freeShippingBase={total} onFreteGratisChange={setFreteGratisRevisao} />
                    )}
                    {mainOptionDelivery && acceptReceiveOnDifferentsDays && (
                        <WarnContainer>
                            <AlertInfo title="Confira os produtos e quantidades antes de finalizar a compra." text={`Alguns produtos da sua cesta estão com datas diferentes para ${mainOptionDelivery.tipoEntrega === DeliveryType.RECEBER_EM_CASA ? 'entrega' : 'retirada'}.`} />

                            <WhatWouldLikeToDoTitleWrap>O que você deseja fazer?</WhatWouldLikeToDoTitleWrap>
                            <StyledInputRadioCustom name="receiveInDifferentsDays" handleChange={handleReveived} options={[{ value: "S", label: `Quero ${mainOptionDelivery.tipoEntrega === DeliveryType.RECEBER_EM_CASA ? 'receber' : 'retirar'} os produtos em datas diferentes` }, { value: "N", label: `Quero ${mainOptionDelivery.tipoEntrega === DeliveryType.RECEBER_EM_CASA ? 'receber' : 'retirar'} todos os produtos em ${mainOptionDelivery.tempo_contingencia_gam}h` }]} rowDirection={false} />
                        </WarnContainer>
                    )}
                    {mainOptionDelivery && (promotionOfProductsWithStock.length > 0 || promotionOfProductsWithoutStock.length > 0) ? (
                        <ContainerProducts>
                            {promotionOfProductsWithStock && promotionOfProductsWithStock.length > 0 && (
                                <div>
                                    <Line>
                                        <DeliveryTitle>Produtos</DeliveryTitle>
                                        {canAttachPrescriptionFile && (
                                            <AttachPrescriptionButton onClick={openAttachPrescriptionsFileModal}>
                                                <FiPaperclip fontSize={20} />Enviar receita
                                            </AttachPrescriptionButton>
                                        )}
                                    </Line>

                                    {
                                        promotionOfProductsWithStock.map((promotion) => (
                                            <ProductCard key={`promotionOfProductsWithStock-${promotion.type}-${promotion.priceId}`} index={`price-${promotion.priceId}`} promotion={promotion} allowHandleQuantity={false} loadingItemInCart={cart.loadingItemInCart} productIdInChanging={cart.productIdChanged} pickupOnly={isPickupOnlyProduct(promotion.product)} />
                                        ))
                                    }
                                </div>
                            )}
                            {promotionOfProductsWithoutStock && promotionOfProductsWithoutStock.length > 0 && (
                                <div>
                                    <Line>
                                        <DeliveryTitle>{mainOptionDelivery?.tipoEntrega === DeliveryType.RECEBER_EM_CASA ? 'Entrega' : 'Retirada'} em até {mainOptionDelivery?.tempo_contingencia_gam}h</DeliveryTitle>
                                        {canAttachPrescriptionFile && !(promotionOfProductsWithStock && promotionOfProductsWithStock.length > 0) && (
                                            <AttachPrescriptionButton onClick={openAttachPrescriptionsFileModal}>
                                                <FiPaperclip fontSize={20} />Enviar receita
                                            </AttachPrescriptionButton>
                                        )}
                                    </Line>

                                    {
                                        promotionOfProductsWithoutStock.map((promotion) => (
                                            <ProductCard key={`promotionOfProductsWithoutStock-${promotion.type}-${promotion.priceId}`} index={`price-${promotion.priceId}`} promotion={promotion} allowHandleQuantity={false} loadingItemInCart={cart.loadingItemInCart} productIdInChanging={cart.productIdChanged} pickupOnly={isPickupOnlyProduct(promotion.product)} />
                                        ))
                                    }
                                </div>
                            )}
                        </ContainerProducts>
                    ) : (
                        <ContainerProducts>
                            <div>
                                <Line>
                                    <DeliveryTitle>Produtos</DeliveryTitle>
                                    {canAttachPrescriptionFile && (
                                        <AttachPrescriptionButton onClick={openAttachPrescriptionsFileModal}> <FiPaperclip fontSize={20} />Enviar receita</AttachPrescriptionButton>
                                    )}
                                </Line>
                                {promotions.map((promotion) => (
                                    <ProductCard key={`promotion-${promotion.type}-${promotion.priceId}`} index={`price-${promotion.priceId}`} promotion={promotion} allowHandleQuantity={false} loadingItemInCart={cart.loadingItemInCart} productIdInChanging={cart.productIdChanged} pickupOnly={isPickupOnlyProduct(promotion.product)} />
                                ))}
                            </div>
                        </ContainerProducts>
                    )}
                </RevisionWrap>
                <PriceInfoWrap>
                    <TitleWrap>Resumo do Pedido</TitleWrap>
                    <PriceInfoContent>
                        <span className="price-description">Subtotal ({textoQuantidadeProdutos(distinctProductsIdCount)})</span>
                        <span className="price-value">{formatPrice(subtotal)}</span>
                    </PriceInfoContent>

                    {subtotal > total && (
                        <PriceInfoContent className="discount">
                            <span className="price-description">Descontos</span>
                            <span className="price-value">- {formatPrice(subtotal - total)}</span>
                        </PriceInfoContent>
                    )}

                    <OrderMinimumNotice valorMinimo={valorMinimoPedido} base={total} />

                    {freteGratisRevisao.ativo && mainOptionDelivery?.tipoEntrega !== DeliveryType.RETIRAR_NA_LOJA && (
                        <FreeShippingProgress
                            valorMinimo={freteGratisRevisao.valorMinimo}
                            base={total}
                        />
                    )}

                    {(mainOptionDelivery?.tipoEntrega === DeliveryType.RECEBER_EM_CASA) && (
                        <PriceInfoContent className="delivery-fee">
                            <span className="price-description">Taxa de entrega</span>
                            {entregaGratisNaRevisao ? (
                                <span className="price-value">+ <span style={{ textDecoration: "line-through" }}>{formatPrice(taxaEntregaCheia)}</span></span>
                            ) : (
                                <span className="price-value">+ {formatPrice(taxaEntregaCheia)}</span>
                            )}
                        </PriceInfoContent>
                    )}
                    {freteGratisSujeitoPagamento && (
                        <FreeShippingNote>Frete grátis sujeito à forma de pagamento</FreeShippingNote>
                    )}

                    <PriceInfoContent className="total">
                        <span className="price-description total">
                            Total
                        </span>
                        <span className="price-value total">{formatPrice(total + taxaEntregaRevisao)}</span>
                    </PriceInfoContent>

                    {descontoPix > 0 && (
                      <PriceInfoContent className="pix-discount">
                        <span className="price-description">No Pix ({formatarPercentual(percPix)}% OFF nos produtos)</span>
                        <span className="price-value">- {formatPrice(descontoPix)}</span>
                      </PriceInfoContent>
                    )}

                    <StyledButtonPrimary
                        onClick={continueToPayment}
                        text="Avançar"
                        disabled={faltaMinimo > 0 || !mainOptionDelivery || (promotionOfProductsWithStock.length > 0 && promotionOfProductsWithoutStock.length > 0 ? receiveInDifferentsDays === undefined : false)}
                    />
                    <StyledButtonSecondary text={"Continuar comprando"} onClick={keepBuying} />
                </PriceInfoWrap>
            </ContentWrap>
            {showAddressSelectionModal && (
                <AddressSelectionModal addresses={addresses} selectedAddress={mainAddress} setSelectedAddress={selectCheckoutAddress} closeModal={() => setShowAddressSelectionModal(false)} showOverlay={setLoadingOverlay} startWithAddressForm={!mainAddress} initialZipCode={deliveryContext.origem === Origem.MANUAL_CEP ? deliveryContext.cep : null} />
            )}
            {showPickupModal && (
                <PickupModal customerAddressId={mainAddress?.id} cart={cart} store={store} closeModal={() => setShowPickupModal(false)} showOverlay={setLoadingOverlay} onChoosePickupStore={onChoosePickupStore} />
            )}
            {showSendPrescriptionFileModal && (
                <ChooseFile
                    title="Envie a receita médica"
                    files={prescriptionFiles}
                    dropzoneText="Clique ou arraste o arquivo da receita médica aqui"
                    dropzoneDescription="A sua cesta contém produtos que necessitam de receita médica. Por favor, envie a receita para que possamos liberar a sua compra."
                    closeModalAction={() => setShowSendPrescriptionFileModal(false)}
                    confirmAction={savePrescriptionToCart}
                    filesLimit={3}
                />
            )}
            <PartlyFulfilledOrderModal onUpdateSuccess={(updatedCart) => confirmContinueToPayment(receiveInDifferentsDays !== undefined ? receiveInDifferentsDays : undefined, updatedCart, true)} />
            <ShowAcceptGetItOnDifferentDays showModal={acceptReceiveOnDifferentsDaysModal} handleCloseModal={() => setAcceptReceiveOnDifferentsDaysModal(false)} handleContinue={async () => { await confirmContinueToPayment(true) }} deliveryType={mainOptionDelivery?.tipoEntrega} />
        </BuyStepsTemplate>
    )
}
